import React from 'react';
import {t} from '@lingui/core/macro';

import {useServerAgentToken} from 'features/server/model/useServerAgentToken';
import MainModal from 'shared/ui/Modal/MainModal';
import LoaderCentered from 'shared/ui/LoaderCentered/LoaderCentered';
import IServerOutput from 'features/server/model/Server/IServer';

import ServerAgentConnectionScreen from '../ServerAgentConnectionScreen/ServerAgentConnectionScreen';

interface IServerSetTokenModalProps {
    item: IServerOutput,
    open: boolean;
    handleClose: () => void;
}

const ServerSetTokenModal: React.FC<IServerSetTokenModalProps> = ({ item, open, handleClose }) => {
    const {server} = useServerAgentToken(item.uuid, open);

    return (
        <MainModal
            header={t`Подключение агента`}
            open={open}
            handleClose={handleClose}
            size="md"
        >
            {
                server
                    ? (
                        <ServerAgentConnectionScreen
                            token={server.agent_token ?? ''}
                            serverUuid={server.uuid}
                            onDone={handleClose}
                        />
                    )
                    : <LoaderCentered active/>
            }
        </MainModal>
    );
};

export default ServerSetTokenModal;
